import React, { useState } from "react";
import style from "./Catalogue.module.css";
import { Button } from "@material-ui/core";
import { CatCard } from "./CatCard/CatCard";
import velaGreen from "./velaGreen.png";
import velaYellow from "./velaYellow.png";
import velaWhite from "./velaWhite.png";
import velaRed from "./velaRed.png";

import aro from "../../assets/velas/Aromaticas/SEA_8366.jpg";
import aro1 from "../../assets/velas/Aromaticas/SEA_8367.jpg";
import aro2 from "../../assets/velas/Aromaticas/SEA_8423.jpg";
import aro3 from "../../assets/velas/Aromaticas/SEA_8424.jpg";

import reli from "../../assets/velas/Religiosas/SEA_7359.jpg";
import reli1 from "../../assets/velas/Religiosas/SEA_7361.jpg";
import reli2 from "../../assets/velas/Religiosas/SEA_7362.jpg";
import reli3 from "../../assets/velas/Religiosas/SEA_7366.jpg";
import reli4 from "../../assets/velas/Religiosas/SEA_7379.jpg";
import reli5 from "../../assets/velas/Religiosas/SEA_7382.jpg";
import reli6 from "../../assets/velas/Religiosas/SEA_7384.jpg";
import reli7 from "../../assets/velas/Religiosas/SEA_7387.jpg";

import gift from "../../assets/velas/GiftSets/SEA_7481.jpg";
import gift1 from "../../assets/velas/GiftSets/SEA_7484.jpg";
import gift2 from "../../assets/velas/GiftSets/SEA_8394.jpg";
import gift3 from "../../assets/velas/GiftSets/SEA_8397.jpg";
import gift4 from "../../assets/velas/GiftSets/SEA_8697.jpg";
import gift5 from "../../assets/velas/GiftSets/SEA_8698.jpg";
import gift6 from "../../assets/velas/GiftSets/SEA_8699.jpg";

let vela1 = {
  nombre: "C026 Liso Repuesto Rojo",
  codigo: "C02600003",
  peso: 113.4,
  altura: 7.5,
  diametroSup: 4.5,
  diametroInf: 4,
  duracion: 5,
};
let fotos = [velaGreen, velaYellow, velaWhite, velaRed];

let fotos2 = [velaWhite, velaRed, velaGreen, velaYellow];

export const Catalogue = () => {
  const [button, setButton] = useState("");

  const Mix = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard img={aro3} nombre="Vela Demo" codigo="C02600001"></CatCard>
          <CatCard img={reli1} nombre="Vela Demo" codigo="C02600001"></CatCard>
          <CatCard img={aro3} nombre="Vela Demo" codigo="C02600001"></CatCard>
          <CatCard img={gift} nombre="Vela Demo" codigo="C02600001"></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard img={gift2} nombre="Vela Demo" codigo="C02600001"></CatCard>
          <CatCard img={reli4} nombre="Vela Demo" codigo="C02600001"></CatCard>
          <CatCard
            img={velaGreen}
            nombre="Vela Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard img={aro} nombre="Vela Demo" codigo="C02600001"></CatCard>
        </div>{" "}
      </div>
    );
  };

  const Decorativas = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>{" "}
      </div>
    );
  };

  const Aromaticas = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard
            img={aro}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro1}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro3}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro2}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard
            img={aro3}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro2}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro1}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={aro}
            nombre="Aromatica Demo"
            codigo="C02600001"
          ></CatCard>
        </div>{" "}
      </div>
    );
  };

  const Religiosas = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard
            img={reli}
            nombre="Religiosas 1"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli1}
            nombre="Religiosas 2"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli2}
            nombre="Religiosas 3"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli3}
            nombre="Religiosas 4"
            codigo="C02600001"
          ></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard
            img={reli4}
            nombre="Religiosas 5"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli5}
            nombre="Religiosas 6"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli6}
            nombre="Religiosas 7"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={reli7}
            nombre="Religiosas 8"
            codigo="C02600001"
          ></CatCard>
        </div>{" "}
      </div>
    );
  };

  const Repelentes = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={fotos}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>{" "}
      </div>
    );
  };

  const GiftSets = () => {
    return (
      <div className={style.catalogue}>
        <div className={style.cardsCont}>
          <CatCard
            img={gift}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift2}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift5}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift3}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>
        <div className={style.cardsCont}>
          <CatCard
            img={gift1}
            nombre="Liso Repuesto Verde"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift4}
            nombre="Liso Repuesto Rojo"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift2}
            nombre="Liso Repuesto Blanco"
            codigo="C02600001"
          ></CatCard>
          <CatCard
            img={gift6}
            nombre="Liso Repuesto Amarillo"
            codigo="C02600001"
          ></CatCard>
        </div>{" "}
      </div>
    );
  };

  const [cat, setCat] = useState(Mix);

  const Navbar = () => {
    const btnHandler = (e) => {
      setButton(e.currentTarget.value);
      e.currentTarget.value == 1 ? setCat(Decorativas) : "";
      e.currentTarget.value == 2 ? setCat(Aromaticas) : "";
      e.currentTarget.value == 3 ? setCat(Religiosas) : "";
      e.currentTarget.value == 4 ? setCat(Repelentes) : "";
      e.currentTarget.value == 5 ? setCat(GiftSets) : "";

      console.log(cat);
    };

    return (
      <div className={style.navbar}>
        <div className={style.btnCont}>
          <Button
            className={button == 1 ? style.navBtnSel : style.navBtn}
            variant="text"
            disableRipple
            color="default"
            value={1}
            onClick={btnHandler}
          >
            Decorativas
          </Button>
          <Button
            className={button == 2 ? style.navBtnSel : style.navBtn}
            variant="text"
            disableRipple
            color="default"
            value={2}
            onClick={btnHandler}
          >
            Aromáticas
          </Button>
          <Button
            className={button == 3 ? style.navBtnSel : style.navBtn}
            variant="text"
            disableRipple
            color="default"
            value={3}
            onClick={btnHandler}
          >
            Religiosas
          </Button>
          <Button
            className={button == 4 ? style.navBtnSel : style.navBtn}
            variant="text"
            disableRipple
            color="default"
            value={4}
            onClick={btnHandler}
          >
            Repelentes
          </Button>
          <Button
            className={button == 5 ? style.navBtnSel : style.navBtn}
            variant="text"
            disableRipple
            color="default"
            value={5}
            onClick={btnHandler}
          >
            Gift Sets
          </Button>
        </div>
      </div>
    );
  };

  return (
    <div className={style.conteiner}>
      <div className={style.NavConteiner}>
        <Navbar></Navbar>
      </div>
      {cat}
    </div>
  );
};
